import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from 'store';
import { RewardPostRequest, RewardPostResponse } from 'types/reward';

type State = {
  rewardList: Array<'halfway' | 'almost' | 'perfect'>;
  isInitialize: boolean; // Suspenseと連動させるためのフラグ
};

const initialState: State = {
  rewardList: [],
  isInitialize: false,
};

const baseUrl = process.env.REACT_APP_API_ENDPOINT || '';

// RTK Queryの設定
export const rewardDataApi = createApi({
  reducerPath: 'rewardDataApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      // ここにカスタムヘッダーを追加します
      // 現在の状態にアクセスします
      const state = getState() as RootState;
      // 状態からユーザートークンを取得します
      const userToken = state.liffUser.userToken;
      headers.set('Content-Type', 'application/json');
      headers.set('Authorization', `Bearer ${userToken}`);
      return headers;
    },
  }),
  tagTypes: ['Reward'],
  endpoints: builder => ({
    postRewardData: builder.mutation<RewardPostResponse, RewardPostRequest>({
      query: ({ id }) => ({
        url: `/reward?id=${id}`, // Here, pass id as a query parameter
        method: 'POST',
      }),
      invalidatesTags: ['Reward'],
    }),
  }),
});

// エンドポイント毎にカスタムhooksが作成される
export const { usePostRewardDataMutation } = rewardDataApi;

const reward = createSlice({
  name: 'reward',
  initialState,

  reducers: {},

  extraReducers: builder => {
    // POST後に状態を取得
    builder.addMatcher(
      rewardDataApi.endpoints.postRewardData.matchFulfilled,
      (state, action: PayloadAction<RewardPostResponse>) => {
        console.log('POST reward fulfilled');

        const { rewardList } = action.payload;

        return {
          ...state,
          rewardList,
          isInitialize: true,
        };
      }
    );
    // POST失敗
    builder.addMatcher(rewardDataApi.endpoints.postRewardData.matchRejected, state => {
      console.error('POST reward rejected');
    });
  },
});

// Reducer
export default reward.reducer;
